import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Ship, Anchor } from "lucide-react";
import { useCruise } from "../context/CruiseContext";
import caribbean from "../data/caribbean";
import europe from "../data/europe";
import escape from "../data/escape";
import { Button } from "./ui/button";

const CRUISES = [
  { key: "escape-2026", data: escape, to: "/escape", isNew: false },
  { key: "caribbean-2027", data: caribbean, to: "/getaway", isNew: false },
  { key: "europe-2027", data: europe, to: "/europe", isNew: true },
];

const CrossPromote = () => {
  const { EVENT } = useCruise();
  const others = CRUISES.filter((c) => c.key !== EVENT.id);

  return (
    <section data-testid="cross-promote" className="relative bg-[#0A0A0A] py-16 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-5">
        <div className="flex items-center justify-center gap-2 text-[var(--hh-gold)] mb-8">
          <Anchor size={16} />
          <p className="font-cond uppercase tracking-[0.4em] text-xs sm:text-sm">Also Sailing With House Heads At Sea</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {others.map(({ key, data, to, isNew }) => {
            const o = data.EVENT;
            return (
              <Link
                key={key}
                to={to}
                data-testid={`cross-promote-link-${to === "/getaway" ? "caribbean" : to === "/europe" ? "europe" : "escape"}`}
                className="group relative block overflow-hidden rounded-2xl border border-white/10 hover:border-[var(--hh-gold)] transition-colors duration-300 min-h-[220px]"
              >
                {isNew && (
                  <div data-testid="cross-promote-new-ribbon" className="absolute top-0 right-0 z-20 w-24 h-24 overflow-hidden pointer-events-none">
                    <span className="absolute right-[-40px] top-[22px] w-[150px] rotate-45 bg-[#E50914] text-white text-center font-cond font-bold uppercase text-[11px] tracking-[0.3em] py-1.5 shadow-lg">
                      New!
                    </span>
                  </div>
                )}
                <div className="absolute inset-0">
                  <img
                    src={data.HERO_IMAGE}
                    alt={`${o.name} ${o.tagline}`}
                    className="w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/40" />
                </div>
                <div className="relative flex flex-col justify-end h-full p-7 min-h-[220px]">
                  <p className="font-cond uppercase tracking-[0.3em] text-[10px] text-white/60 mb-1">{o.year}</p>
                  <h3 className="font-cond font-bold uppercase text-white text-3xl sm:text-4xl leading-none">{o.tagline}</h3>
                  <p className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-white/70 font-cond uppercase tracking-widest text-xs">
                    <span className="inline-flex items-center gap-1"><Ship size={13} /> {o.ship}</span>
                    <span className="text-white/30">•</span>
                    <span>{o.dateShort}</span>
                  </p>
                  <div className="mt-5">
                    <Button className="bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest rounded-full px-6 h-11">
                      Explore Cruise
                      <ArrowRight size={15} className="ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CrossPromote;
